<script setup>
import { onMounted } from "vue"
import { ref } from "@vue/reactivity"
import router from "./router"
import { KNOLIA } from "./knolia";
import BootstrapMenu from "./components/bootstrap/BootstrapMenu.vue";
import Profile from "./components/Profile.vue"
import { useUserStore } from '@/store/modules/user.js'

const reload = ref(false)
const reloadMenu = ref(false)
const canShowProfileModal = ref(false)
const userStore = useUserStore()

onMounted(async () => {
  KNOLIA.CheckCredentials(router.currentRoute.value.meta.requiresAuth);
})
</script>

<template>
  <div class="app-container app-container-bg">
    <div class="div-master" id="div-master" v-if="router.currentRoute.value.path != '/privacy'">  
      <BootstrapMenu :key="reloadMenu" @open-profile="canShowProfileModal = true" :user-store="userStore"/>

      <div class="div-content">
        <router-view v-slot="{ Component }">
          <keep-alive include="Users">
            <component :is="Component" :key="reload" @force-reload="reloadMenu = !reloadMenu" :user-store="userStore"/>
          </keep-alive>
        </router-view>
      </div>
    </div>

    <div v-else>
      <router-view :user-store="userStore"/>
    </div>
  </div>

  <Profile v-if="canShowProfileModal" @close-profile-modal="canShowProfileModal = false" @force-reload="reloadMenu = !reloadMenu" :user-store="userStore"/>
</template>

<style scoped>

.app-container {
  /* min-width: 1800px; */
  min-height: 100vh;
}

.div-master {
  /* width: 100vw; */
  display: flex;
  min-height: calc(100vh - var(--navbar-height));
}

.div-content {
  width: calc(100% - 230px);
}

@media screen and (max-width: 767px) {

  .div-master {
    display: flex;
    flex-direction: column;
  }

  .div-content {
    width: 100%;
  }
}

</style>
